import { render, staticRenderFns } from "./GridGuides.vue?vue&type=template&id=52953dd2&"
import script from "./GridGuides.vue?vue&type=script&lang=js&"
export * from "./GridGuides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52953dd2')) {
      api.createRecord('52953dd2', component.options)
    } else {
      api.reload('52953dd2', component.options)
    }
    module.hot.accept("./GridGuides.vue?vue&type=template&id=52953dd2&", function () {
      api.rerender('52953dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/guides/grid/GridGuides.vue"
export default component.exports